import { render, staticRenderFns } from "./DashboardMarketOrders.vue?vue&type=template&id=0bc00ed4&"
import script from "./DashboardMarketOrders.vue?vue&type=script&lang=js&"
export * from "./DashboardMarketOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports